module.exports = __webpack_public_path__ + "static/media/galerija_2016 (8).0a5d4967.jpg";